// src/router/companhias-transporte.js

// Quem abre estas telas (TRI-107; o admin passa). Aplicado pelo guard de @/router/permissoes.js,
// que o menu lateral também usa.
const ROLES = ['coordenador_operacional']

const companhiasTransporteBreadCrumb = [
    {
        label: 'Home',
        to: 'Home'
    },
    {
        label: 'Companhia de transporte',
        to: 'CompanhiasTransporte'
    }
]

export default [
    {
        path: '/companhias-transporte',
        name: 'CompanhiasTransporte',
        component: () => import('@/views/CompanhiasTransporte/CompanhiaTransporteListPage.vue'),
        meta: {
            roles: ROLES,
            title: 'Companhia de transporte',
            breadcrumb: companhiasTransporteBreadCrumb
        },
    },
    {
        path: '/companhias-transporte/novo',
        name: 'CompanhiaTransporteNovo',
        component: () => import('@/views/CompanhiasTransporte/NovoCompanhiaTransportePage.vue'),
        meta: {
            roles: ROLES,
            title: 'Nova Companhia Transporte',
            breadcrumb: [
                ...companhiasTransporteBreadCrumb,
                {
                    label: 'Nova Companhia de trasporte',
                    to: 'CompanhiaTransporteNovo'
                }
            ]
        }
    },
    {
        path: '/companhias-transporte/:id/detalhes',
        name: 'CompanhiaTransporteDetalhes',
        component: () => import('@/views/CompanhiasTransporte/NovoCompanhiaTransportePage.vue'),
        meta: {
            roles: ROLES,
            title: 'Detalhes da Companhia de transporte',
            breadcrumb: [
                ...companhiasTransporteBreadCrumb,
                {
                    label: 'Nova Companhia de trasporte',
                    to: 'CompanhiaTransporteNovo'
                }
            ]
        }
    }
];
